import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { IQuestionsWithAnswersModifiedResponse } from 'src/app/interfaces/questionManagement';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { FlashCardManagementService } from 'src/app/Services/flashcard-management.service';
import { IRelocateQuestionPayload, QuestionManagementService } from 'src/app/Services/question-management.service';
import { ITreeNode } from '../../content-management/content-studyunit-topics/content-studyunit-topics.component';
import { SessionService } from 'src/app/Services/session.service';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-relocate-question-modal',
  templateUrl: './relocate-question-modal.component.html',
  styleUrls: ['./relocate-question-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RelocateQuestionModalComponent implements OnInit {
  @Input() selectedQuestions: IQuestionsWithAnswersModifiedResponse[];
  @Input() selectedSubject: any;
  @Input() fromSubject: number;
  MajorTopics: ITreeNode[];
  selectedNodes: {
    ID: number;
    Display_Order: number;
  }[] = []; 
  anyNodeChecked: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public questionService: QuestionManagementService,
    public flashService: FlashCardManagementService,
    private readonly toaster: ToastrService,
    private modalService: NgbModal,
    public service: ContentManagementService,
  ) {}


  ngOnInit(): void {
    console.log(this.selectedSubject);
    this.loadInitialData(this.selectedSubject);
  }
  loadInitialData(id: number) {
    const payload = {
      ScreenName: 'SUBJECT BREAKDOWN',
      CurrentNodeID: id,
      ChildRecordStatus: 'ALL',
      CalledFrom: null,
    };

    this.service.getSubjectTree(payload).subscribe(
      (res: ITreeNode[]) => {
        this.MajorTopics = res;

        // ✅ Expand all nodes AFTER data is loaded
        this.expandAllNodes();
      },
      (error) => console.error(error)
    );
  }
  expandAllNodes() {
    this.recursivelyExpandNodes(this.MajorTopics);
  }

  recursivelyExpandNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      if (node.ChildNodeExistInd === 'Y') {
        this.getSubjectTree(node);
      }
      if (node.Data) {
        this.recursivelyExpandNodes(node.Data);
      }
    });
  }

  getSubjectTree(node: ITreeNode) {
    if (!node || node.ChildNodeExistInd !== 'Y' || node.Data) return; // Prevent unnecessary API calls

    const payload = {
      ScreenName: 'SUBJECT BREAKDOWN',
      CurrentNodeID: node.ID,
      ChildRecordStatus: 'ALL',
      CalledFrom: null,
    };

    this.service.getSubjectTree(payload).subscribe(
      (res: ITreeNode[]) => {
        node.Data = res; // Populate child nodes
        this.recursivelyExpandNodes(node.Data); // ✅ Expand fetched children
      },
      (error) => console.error(error)
    );
  }
  enableDisableCheckBox(node: ITreeNode): boolean {
    if (this.anyNodeChecked) {
      // If any node is checked, disable all except the one that is already checked
      return !node.checked;
    }
    return false; // If none checked, don't disable any
  }
  
  onCross() {
    this.activeModal.close(false);
  }
  onSave() {
    if(this.selectedNodes.length === 0){
      this.toaster.error('Please select a topic to relocate the questions',"",{ timeOut: ConstantVars.ToastErrorTimeout});
      return;
    }
    const modalRef = this.modalService.open(ConfirmRelocateModalComponent, {
      size: 'lg',
      centered: true,
      scrollable: true,
      windowClass: 'custom-confirm-relocate-modal-width-list',
    });
  
    // Pass selected questions to confirm modal
    modalRef.componentInstance.selectedQuestions = this.selectedQuestions;
    modalRef.componentInstance.selectedTopic = this.selectedNodes;
    modalRef.componentInstance.fromSubject= this.fromSubject;
    modalRef.result.then((result) => {
      if (result === 'confirm' ) {
        console.log('User confirmed relocation!');
        // ✅ Now you can call your relocate API or process
        this.activeModal.close('Saved');
      } if(result === 'cancel'){
        this.activeModal.close('cancel');
      }
    }, (reason) => {
      console.log('User cancelled');
    });
  }
  
  onCheckboxChange(node: ITreeNode) {
    this.selectedNodes = this.getCheckedNodes(this.MajorTopics);
    
    // Check if any node is checked
    this.anyNodeChecked = this.isAnyNodeChecked(this.MajorTopics);
  }
  isAnyNodeChecked(nodes: ITreeNode[] | null): boolean {
    if (!nodes) return false;
  
    for (let node of nodes) {
      if (node.checked) {
        return true;
      }
      if (node.Data && this.isAnyNodeChecked(node.Data)) {
        return true;
      }
    }
    return false;
  }
  
  getCheckedNodes(nodes: ITreeNode[] | null): {
    ID: number;
    Display_Order: number;
    TestingProbabilityTypeCode?: string | null;
  }[] {
    if (!nodes) return [];

    let selected: {
      ID: number;
      Display_Order: number;
      TestingProbabilityTypeCode?: string | null;
    }[] = [];

    nodes.forEach((node) => {
      if (node.checked) {
        selected.push({
          ID: node.ID,
          Display_Order: node.Display_Order,
          TestingProbabilityTypeCode: node.TestingProbabilityTypeCode || null,
        });
      }
      if (node.Data) {
        selected = selected.concat(this.getCheckedNodes(node.Data));
      }
    });

    return selected;
  }
  onSelectedNodesChange(
    selectedNodes: {
      ID: number;
      Display_Order: number;
      TestingProbabilityTypeCode?: string | null;
    }[]
  ) {
    this.selectedNodes = selectedNodes;
    this.anyNodeChecked = this.selectedNodes.length > 0; // ✅ correct
  }
  

}


// QUESTION CHILD NODES
@Component({
  selector: 'app-question-topics-node',
  styleUrls: ['./relocate-question-modal.component.css'],
  template: `
    <div class="row tree-row" *ngFor="let node of treeNodes">
      <div class="col-12 d-flex align-items-baseline">
        <div class="px-1 tree-btn-1">
          <button
            type="button"
            class="tree-btn"
            *ngIf="node.ChildNodeExistInd === 'Y'"
            (click)="getSubjectTree(node)"
          >
            <i class="fa fa-angle-right" *ngIf="!node.Data"></i>
            <i class="fa fa-angle-down" *ngIf="node.Data"></i>
          </button>
        </div>

        <app-tree-content
          [Text]="node.Name"
          [status]="node.Status_Code"
          ID="node.ID"
        ></app-tree-content>

        <!-- ✅ Bind checkbox to node.checked -->
        <div class="d-flex align-items-center">
          <input
            type="checkbox"
            class="form-check-input-sm"
            [(ngModel)]="node.checked"
            [disabled]="enableDisableCheckBox(node)"
            (change)="onCheckboxChange(node)"
            *ngIf="node.ChildNodeExistInd === 'N'"
          />
        </div>
      </div>

      <div *ngIf="node.Data" class="ms-4">
      <div *ngIf="node.Data" class="ms-4">
  <app-question-topics-node
    [treeNodes]="node.Data"
    [selectedNodes]="selectedNodes"
    [anyNodeChecked]="anyNodeChecked"   
    (selectedNodesChange)="onSelectedNodesChange($event)">
  </app-question-topics-node>
</div>


      </div>
    </div>
  `,
  
})
export class QuestionTopicsNodeComponent implements OnInit {
  @Input() treeNodes: ITreeNode[] | null = null;
  @Input() anyNodeChecked: boolean = false;
  @Input() selectedNodes: {
    ID: number;
    Display_Order: number;
    TestingProbabilityTypeCode?: string | null;
  }[] = [];

  @Output() selectedNodesChange = new EventEmitter<{ ID: number; Display_Order: number }[]>();

  constructor(private service: ContentManagementService) {}

  ngOnInit() {
    this.markSelectedNodes(this.treeNodes);
    this.onCheckboxChange();
  }

  getSubjectTree(node: ITreeNode) {
    if (!node || node.ChildNodeExistInd !== 'Y') return;

    if (node.Data) {
      node.Data = null; // Collapse
    } else {
      const payload = {
        ScreenName: 'SUBJECT BREAKDOWN',
        CurrentNodeID: node.ID,
        ChildRecordStatus: 'ALL',
        CalledFrom: null,
      };

      this.service.getSubjectTree(payload).subscribe((res: ITreeNode[]) => {
        node.Data = res;
        this.recursivelyExpandNodes(node.Data);
        this.markSelectedNodes(node.Data);
      });
    }
  }

  markSelectedNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      node.checked = this.selectedNodes.some(selected => selected.ID === node.ID);
      node.previous = this.selectedNodes.some(selected => selected.ID === node.ID);
      node.TestingProbabilityTypeCode = this.selectedNodes.find(selected => selected.ID === node.ID)?.TestingProbabilityTypeCode || null;

      if (node.Data) {
        this.markSelectedNodes(node.Data);
      }
    });
  }

  onCheckboxChange(node?: ITreeNode) {
    this.selectedNodesChange.emit(this.getCheckedNodes(this.treeNodes));
  }

  onTestingProbabilityChange(item: any, selectedCode: string) {
    item.TestingProbabilityTypeCode = selectedCode;
    this.selectedNodesChange.emit(this.getCheckedNodes(this.treeNodes));
  }

  onSelectedNodesChange(selectedNodes: { ID: number; Display_Order: number }[]) {
    this.selectedNodesChange.emit(selectedNodes); // ✅
  }
  
  
  

  getCheckedNodes(nodes: ITreeNode[] | null): { ID: number; Display_Order: number }[] {
    if (!nodes) return [];

    let selected: { ID: number; Display_Order: number }[] = [];
    nodes.forEach((node) => {
      if (node.checked) {
        selected.push({ ID: node.ID, Display_Order: node.Display_Order });
      }
      if (node.Data) {
        selected = selected.concat(this.getCheckedNodes(node.Data));
      }
    });

    return selected;
  }

  recursivelyExpandNodes(nodes: ITreeNode[] | null) {
    if (!nodes) return;

    nodes.forEach((node) => {
      if (node.ChildNodeExistInd === 'Y' && !node.Data) {
        this.getSubjectTree(node);
      }
      if (node.Data) {
        this.recursivelyExpandNodes(node.Data);
      }
    });
  }

  enableDisableCheckBox(node: ITreeNode): boolean {
    if (this.anyNodeChecked) {
      return !node.checked;
    }
    return false;
  }
}

// # Confirm Relocate Modal

@Component({
  selector: 'app-confirm-relocate-modal',
  styles: [
    `
    .custom-confirm-relocate-modal-width-list .modal-dialog {
      max-width: 95vw !important;
      width: 95vw !important;
      height: 90vh !important;
    }
    `
  ],
  template: `
    <div class="modal-header">
      <h5 class="modal-title">Confirm Relocate Questions</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('cancel')"></button>
    </div>

    <div class="modal-body">

<!-- Heading -->
<p class="fw-semibold mb-3">The following questions are getting relocated:</p>

<!-- From → To Path Row -->
<div class="p-3 rounded bg-light border d-inline-flex align-items-center gap-3 mb-3" style="min-width:270px;">
  <span>
    <strong class="text-secondary">From:</strong>
    <span class="text-dark ms-1">{{ fromPath }}</span>
  </span>
  <span class="mx-2" aria-label="arrow">
    <i class="bi bi-arrow-right text-primary" style="font-size:1.3em;"></i>
  </span>
  <span>
    <strong class="text-secondary">To:</strong>
    <span class="text-dark ms-1">{{ toPath }}</span>
  </span>
</div>

<!-- Questions List -->
<div class="row g-3 px-2" style="height: 68vh; overflow-y: auto;">
  <div class="col-12 col-md-6" *ngFor="let question of tempSelectedQuestions; let i = index">
    <app-question-card 
      [question]="question"
      [relocateQuestions]="true"
      [editQuestions]="false"
      [index]="i"
      (relocateCheckboxChanged)="onRelocateCheckboxChange($event)"
      (editClicked)="triggerParentFunction($event)">
    </app-question-card>
  </div>
</div>
</div>

    <div class="modal-footer">
      <button type="button"  class="bl-btn btn btn-sm px-3" (click)="confirm()">Confirm</button>
      <button type="button" class="btn btn-sm bg-light border px-3" (click)="activeModal.dismiss('cancel')">Cancel</button>
    </div>
  `,
  encapsulation: ViewEncapsulation.None
})
export class ConfirmRelocateModalComponent {
  @Input() selectedQuestions: any[] = [];
  @Input() selectedTopic: any;
  @Input() fromSubject:number;
  tempSelectedQuestions: any[] = [];
  fromPath: string;
  toPath: string;
  constructor(public activeModal: NgbActiveModal,
    private questionService: QuestionManagementService,
    private session: SessionService,
    private toaster: ToastrService
  ) {}
  ngOnInit(): void {

    this.tempSelectedQuestions = [...this.selectedQuestions];  
    this.getPathFrom();
    this.getPathTo()
  }
  
  getPathFrom(){
    const pathPayload = {
      SubjectId: this.fromSubject,
      Screenname: 'ADMIN_QUESTION_LIST',
    };
    this.questionService.getPath$(pathPayload).subscribe((e)=>{
      this.fromPath = e
      console.log(this.fromPath,"FromOath");
      
    })
  }
  getPathTo(){
    const pathPayload = {
      SubjectId: this.selectedTopic[0].ID,
      Screenname: 'ADMIN_QUESTION_LIST',
    };
    this.questionService.getPath$(pathPayload).subscribe((e)=>{
      this.toPath = e
      console.log(this.toPath,"ToPath");

    })
  }
  onRelocateCheckboxChange(event: { question: any, selected: boolean }) {
    const index = this.tempSelectedQuestions.findIndex(
      (q) => q.Question_ID === event.question.Question_ID
    );
  
    if (index !== -1) {
      // Update selection status
      this.tempSelectedQuestions[index].selectedForRelocation = event.selected;
    } else if (event.selected) {
      // If not already added and selected, push and mark selected
      this.tempSelectedQuestions.push({
        ...event.question,
        selectedForRelocation: true,
      });
    }
  
    console.log(this.tempSelectedQuestions);
  }
  
  
  triggerParentFunction(question: any) {
    console.log(question);
  }
  confirm() {
    const payload: IRelocateQuestionPayload = {
      LoggedInUser: this.session.getUser(),
      UDTRelocateMultipleQuestions: this.tempSelectedQuestions.filter(question => question.selectedForRelocation).map(question => ({ QuestionID: question.Question_ID })),
      SubjectID: this.selectedTopic[0].ID,
      ErrorMessage: '',
      SuccessIND: 'Y'
    };

    this.questionService.relocateQuestions$(payload).subscribe((res:any)=>{
      this.toaster.success('Questions relocated successfully',"",{ timeOut: ConstantVars.ToastSucessTimeout});
      this.activeModal.close('confirm');
    },(error:any)=>{
      this.toaster.error('Error relocating questions',"",{ timeOut: ConstantVars.ToastErrorTimeout});
    });
  }
}